import { ProductStatus } from '@today/types'

/** The one lifecycle action per status (TO-416 product-admin-ui REQ-007). There is no PAUSED. */
export type LifecycleActionId = 'publish' | 'retire' | 'reactivate'

const ACTIONS: Partial<Record<ProductStatus, { action: LifecycleActionId; targetStatus: ProductStatus }>> = {
	[ProductStatus.DRAFT]: { action: 'publish', targetStatus: ProductStatus.ACTIVE },
	[ProductStatus.ACTIVE]: { action: 'retire', targetStatus: ProductStatus.RETIRED },
	[ProductStatus.RETIRED]: { action: 'reactivate', targetStatus: ProductStatus.ACTIVE },
}

export const lifecycleAction = (status: ProductStatus) => ACTIONS[status] ?? null

/** Moves into ACTIVE (publish, reactivate) need every required translation; retire never does. */
export const actionEnabled = (action: LifecycleActionId, publishable: boolean): boolean =>
	action === 'retire' || publishable
